'use strict';

// @flow

var DefaultTimezone = 'America/Los_Angeles';

var TeamUtils = {
  COLOR_INVITEE: '#CfD2D5',
  COLORS_MEMBERS: ['#cd6d38', '#b04f4f', '#a35286', '#8f52a3', '#6649a1', '#4f4fa3', '#179b93', '#4fa360', '#a3a34f', '#cdc638'],
  getWorkerColor: function getWorkerColor(access) {
    switch (access) {
      case 'invitee':
        return TeamUtils.COLOR_INVITEE;
      default:
        {
          // Create a new random color
          var randomIndex = Math.floor(Math.random() * TeamUtils.COLORS_MEMBERS.length);
          return TeamUtils.COLORS_MEMBERS[randomIndex];
        }
    }
  },


  createTeam: function createTeam(updates, timestamp, team, //: { id : string, displayName : string, color: string }
  creatorId) {
    if (!team.color) {
      team.color = '#059588';
    }

    updates['teams/' + team.id + '/metadata/'] = {
      id: team.id,
      color: team.color,
      displayName: team.displayName,
      creationTimestamp: timestamp,
      timezone: DefaultTimezone,
      onboardedFrom: team.onboardedFrom || 'mobile',
      creatorId: creatorId
    };

    updates['teams/' + team.id + '/templates'] = DEFAULT_TEMPLATES;
    return updates;
  },

  addUserToTeam: function addUserToTeam(updates, timestamp, team, //: { id: string },
  user, //: { id: string, displayName: string },
  userTeam //: { role: string, access: string },
  ) {
    var color = TeamUtils.getWorkerColor(userTeam.access);

    var info = {
      teamId: team.id,
      userId: user.id,
      displayName: user.displayName,
      fullName: user.fullName || '',
      role: userTeam.role || '',
      access: userTeam.access,
      email: user.email || '',
      color: color
    };

    updates['teams/' + team.id + '/members/' + user.id] = info;
    updates['users/' + user.id + '/teams/' + team.id] = info;

    return updates;
  },

  removeUserFromTeam: function removeUserFromTeam(updates, timestamp, team, //: { id: string },
  member //: { userId: string, displayName: string },
  ) {

    updates['teams/' + team.id + '/members/' + member.userId + '/delete'] = true;
    updates['users/' + member.userId + '/teams/' + team.id + '/delete'] = true;

    return updates;
  },

  createTeamInvite: function createTeamInvite(updates, timestamp, team, //: { id: string, displayName: string },
  invitationOwner, //: { id: string, role: string, displayName: string },
  invitee //: { id: string, displayName: string}
  ) {
    var inviteInfo = {
      teamId: team.id,
      teamName: team.displayName,
      inviteeId: invitee.id,
      inviteeName: invitee.displayName,
      invitationOwnerId: invitationOwner.id,
      invitationOwnerName: invitationOwner.displayName,
      invitationOwnerRole: invitationOwner.role
    };

    updates['teams/' + team.id + '/userInvites/' + invitee.id] = inviteInfo;
    updates['users/' + invitee.id + '/teamInvites/' + team.id] = inviteInfo;

    return updates;
  },

  deleteTeamInvite: function deleteTeamInvite(updates, timestamp, team, //: { id: string },
  invitee //: { id: string }
  ) {
    updates['teams/' + team.id + '/userInvites/' + invitee.id] = null;
    updates['users/' + invitee.id + '/teamInvites/' + team.id] = null;

    return updates;
  },

  convertInviteeToMember: function convertInviteeToMember(updates, timestamp, team, //: { id: string },
  invitee, //: { id: string, role: string },
  helloMessage //: string
  ) {
    TeamUtils.deleteTeamInvite(updates, timestamp, team, invitee);

    // Change access
    updates['teams/' + team.id + '/members/' + invitee.id + '/access'] = 'member';
    updates['teams/' + team.id + '/members/' + invitee.id + '/role'] = invitee.role;
    updates['teams/' + team.id + '/members/' + invitee.id + '/email'] = invitee.email;
    updates['users/' + invitee.id + '/teams/' + team.id + '/access'] = 'member';
    updates['users/' + invitee.id + '/teams/' + team.id + '/role'] = invitee.role;

    // Set a member color
    var memberColor = TeamUtils.getWorkerColor('member');
    updates['users/' + invitee.id + '/teams/' + team.id + '/color'] = memberColor;
    updates['teams/' + team.id + '/members/' + invitee.id + '/color'] = memberColor;

    // Propagate userMetadata
    updates['queue/userMetadata/' + invitee.id] = true;

    if (helloMessage) {
      updates['queue/helloMessage/' + invitee.id] = {
        teamId: team.id,
        text: helloMessage
      };
    }
  }
};

var DEFAULT_TEMPLATES = {
  "events": {
    "install": {
      "displayName": "Install",
      "modules": {
        "address": {
          "_type": "initial"
        },
        "clockingLineItems": {
          "_type": "initial"
        },
        "contactInfo": {
          "_type": "initial"
        },
        "date": {
          "_type": "service"
        },
        "description": {
          "_type": "initial"
        },
        "displayName": {
          "_type": "initial"
        },
        "laborers": {
          "_type": "initial"
        },
        "lineItems": {
          "_type": "initial"
        },
        "materials": {
          "_type": "initial"
        },
        "notesExtended": {
          "_type": "initial"
        },
        "photos": {
          "_type": "initial"
        },
        "tasks": {
          "_type": "shared"
        },
        "workers": {
          "_type": "initial"
        }
      }
    },
    "recurrent": {
      "displayName": "Recurrent",
      "modules": {
        "address": {
          "_type": "initial",
          "value": ""
        },
        "clockingWorker": {
          "_type": "initial",
          "target": 0
        },
        "contactInfo": {
          "_type": "initial",
          "value": ""
        },
        "date": {
          "_type": "service",
          "recurrence": {
            "repeatOcurrency": 1,
            "repeats": "weekly"
          }
        },
        "description": {
          "_type": "initial",
          "value": ""
        },
        "displayName": {
          "_type": "initial",
          "value": ""
        },
        "materials": {
          "_type": "initial"
        },
        "notesExtended": {
          "_type": "initial"
        },
        "photos": {
          "_type": "initial"
        },
        "tasksInstance": {
          "_type": "initial"
        },
        "tasksRecurrent": {
          "_type": "initial"
        },
        "workers": {
          "_type": "initial"
        }
      }
    },
    "templateService": {
      "displayName": "Service",
      "modules": {
        "address": {
          "_type": "initial"
        },
        "clockingWorker": {
          "_type": "initial",
          "target": 0
        },
        "contactInfo": {
          "_type": "initial"
        },
        "date": {
          "_type": "service"
        },
        "description": {
          "_type": "initial"
        },
        "displayName": {
          "_type": "initial"
        },
        "materials": {
          "_type": "initial"
        },
        "notesExtended": {
          "_type": "initial"
        },
        "photos": {
          "_type": "initial"
        },
        "tasks": {
          "_type": "shared"
        },
        "workers": {
          "_type": "initial"
        }
      }
    }
  },
  "timesheet": {
    "mainTimesheet": {
      "modules": {
        "billable": {
          "_type": "initial"
        },
        "lineItems": {
          "_type": "initial"
        },
        "clockingDay": {
          "_type": "initial"
        },
        "notesEndDay": {
          "value": ""
        },
        "jobsSummary": {
          "_type": "initial"
        },
        "signature": {
          "_type": "initial"
        }
      }
    }
  }
};

module.exports = TeamUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/TeamUtils.js
// module id = 116
// module chunks = 0